import React, { useContext } from 'react'
import  { Redirect } from 'react-router-dom'
import * as PropTypes from 'prop-types'
import { get, keys } from 'lodash'
import { MenuContext, BookInfo } from '../../contexts/menuContext'
import TabsMenuTree from './tabsMenuTree'
import ChapterMenuNavigation, { AppendicesMenuNavigation } from './chapterMenuNvigation'
import IndexMenu from './indexMenu'

const TabsMenu = ({ navigation, activeMenu, changeActiveMenu, appendicesMenu, materialsMenu }) => {
  // Predefine state for the menu activations on menu based on the tree structure.
  const [menuStatus, changeMenuStatus] = useContext(MenuContext)
  const [book, setBook, , setPage, , , overlay] = useContext(BookInfo)
  // Place variable for the menu content.
  // eslint-disable-next-line no-shadow
  const menu = [{
    key: 'chapters',
    name: 'Chapters',
    content: <ChapterMenuNavigation navigation={navigation} />,
  }]
  const availableMenu = keys(get(book, 'relationships.navigation'))
  if (availableMenu.includes('appendix')) {
    menu.push({
      key: 'appendices',
      name: 'Appendices',
      content: <AppendicesMenuNavigation appendicesMenu={appendicesMenu} materialsMenu={materialsMenu} />,
    })
  }

  if (availableMenu.includes('index')) {
    menu.push({ key: 'index', name: 'Index', content: <IndexMenu /> })
  }

  if (availableMenu.includes('companion_material')) {
    const companionMaterialLink = get(book, 'relationships.navigation')['companion_material']
    menu.push({
      key: 'materials',
      name: 'Companion materials',
      content: <></>,
      link: companionMaterialLink,
    })
  }
  // Handler to change menu state.
  const changeOnClickMenu = (e, toggle = false) => {
    if (document.querySelector('#bookreader')) {
      const topPos = document.querySelector('#bookreader').offsetTop
      document.querySelector('body').scrollTop = topPos
    }
    changeActiveMenu(e)
    if (toggle) {
      changeMenuStatus(!menuStatus)
    }
  }

  return (
    <>
      <div className={menuStatus ? 'left-sidebar' : 'left-sidebar minimised'}>
        <div className={`overlay status-${overlay}`} />
        <h2>Contents </h2>
        <div className="app-tabs-horizontal">
          {/*Render Tabs*/}
          <TabsMenuTree menu={menu} activeMenu={activeMenu} changeOnClickMenu={changeOnClickMenu} />
          <div className="tab-content" id="tabContent">
            {menu.map((item, value) => {
              const additionalClass = item.key === activeMenu ? 'active' : 'hidden'
              return (
                <div
                  key={item.key}
                  className={`tab-pane fade show ${additionalClass}`}
                  id={item.key}
                  role="tabpanel"
                  aria-labelledby={item.key}
                >
                  {item.content}
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <div className={menuStatus ? 'left-collapsed-sidebar' : 'left-collapsed-sidebar minimised'}>
        <div className="app-tabs-vertical">
          {/*Render vertical Tabs*/}
          <TabsMenuTree
            menu={menu}
            activeMenu={activeMenu}
            changeOnClickMenu={changeOnClickMenu}
            menuTrigger
          />
        </div>
      </div>
    </>
  )
}

TabsMenu.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
}

export default TabsMenu
